import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const Inquiry = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [contents, setContents] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !address) {
      Swal.fire({
        title: "이름, 연락처, 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact", {
        name: name,
        phone: phone,
        address: address,
        service: "",
        type: null,
        contents: contents,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };
  return (
    <div className="relative w-full h-full bg-white pt-5 text-left">
      <div className=" relative w-full h-full text-black grid gap-5">
        <div className="relative w-full h-full lg:flex items-center">
          <label htmlFor="name" className="lg:text-xl lg:w-28">
            이름&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <input
            type="text"
            placeholder="이름을 입력해주세요"
            value={name}
            id="name"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="relative w-full h-full lg:flex items-center">
          <label htmlFor="phone" className="lg:text-xl lg:w-28">
            연락처&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <input
            type="text"
            placeholder="연락처를 입력해주세요"
            value={phone}
            id="phone"
            onChange={(e) => setPhone(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))}
          />
        </div>
        <div className="relative w-full h-full lg:flex items-center">
          <label htmlFor="address" className="lg:text-xl lg:w-28">
            주소&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <input
            type="text"
            placeholder="주소를 입력해주세요"
            id="address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>
        <div className="relative w-full h-full lg:flex items-start">
          <label htmlFor="service1" className="lg:text-xl lg:w-28">
            내용&nbsp;<span className="text-[var(--red-color)]">*</span>
          </label>
          <div className=" relative w-full h-fit flex items-center gap-2">
            <textarea
              placeholder="내용을 입력해주세요"
              value={contents}
              name="contents"
              id="contents"
              className="lg:!h-36"
              onChange={(e) => setContents(e.target.value)}
            ></textarea>
          </div>
        </div>
        <div className="relative w-full h-fit py-2">
          <div className="lg:pl-28 ">
            <p className="leading-tight text-sm xl:text-lg relative w-full h-fit">
              ( 문의 후 최대 10분안에 연락드립니다 )
            </p>
            <div className="flex items-center gap-1 pb-12">
              <input type="checkbox" name="privacy" id="privacy" defaultChecked checked={true} className="!w-3 !h-3" />
              <label htmlFor="privacy">
                <p className="text-sm xl:text-lg">개인정보처리방침&nbsp;동의</p>
              </label>
            </div>
            <button
              type="button"
              onClick={handlerPostContact}
              disabled={loading}
              className="relative w-full rounded-md bg-gradient-to-r from-[#0d1f52] via-[#20489f] to-[#0d1f52] py-3 text-center shadow-md transition-transform hover:-translate-y-0.5 disabled:opacity-60"
            >
              <span className="gbold text-point md:text-lg lg:text-xl">
                전송하기
              </span>
              <span className="glight text-white md:text-lg lg:text-xl">
                {" "}
                ( 빠른 상담요청 010-5762-2738 )
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inquiry;
